export const color = {
  Primary_Color: "#2b95e8",
  DANGER_COLOR:"#D72A2A",
  Hr_Color: '#ccc',
  IN_ACTIVE:'#ccc',
  //--------SIDEBAR----------------------//
  Sidebar_Background: "#1e1e2d",
  Sidebar_Text: "#9899ac",
  Sidebar_Text_Highlighted: "#ffffff",
  Sidebar_Icon: "#9899ac",
  Sidebar_Icon_Highlighted: "#0095e8",
  Sidebar_Responsive_Arrow_Icon: "#0095e8",
  Sidebar_List_Row_Highlighted: "rgba(0, 0, 0, 1)",
  Sidebar_Link_Background_Active: "#000",
  Sidebar_Link_Color_Active: "#fff",

  //----------HEADER----------------------//
  Header_Background: "#fff",
  Header_Mail_Icon: "#0095e8",
  Header_Notification_Icon: "#0095e8",
  Header_Global_Icon: "#0095e8",
  Avatar_Letter_Color: "#2b95e8",

  //----------Dashboard----------------------//

  Orders_Card_Background: "linear-gradient(30deg,#00c6ff,#0072ff)",
  Cancelled_Card_Background: "linear-gradient(30deg,#ED213A,#d5847b)",
  Delivered_Card_Background: "linear-gradient(30deg,#11998e,#38ef7d)",
  Revenue_Card_Background: "linear-gradient(30deg,#7F00FF,#E100FF)",
  Card_Count_Color: "#000",

  Service_Card_Background: "#fff",
  service_card_text_color : "#181C32",

  // --------Report-----------------//

  total_Card_Background: "linear-gradient(30deg,#00c6ff,#0072ff)",
  finish_Card_Background: "linear-gradient(30deg,#ED213A,#d5847b)",
  reject_Card_Background: "linear-gradient(30deg,#11998e,#38ef7d)",
  cancel_Card_Background: "linear-gradient(30deg,#7F00FF,#E100FF)",

  //----------Parking Dashboard----------------------//

  Parking_Card_Background:"white",

  //----------Datatable Icons----------------------//
  Datatable_Icon_Color: "#ffffff",
  Datatable_Info_Icon_bgColor: "#2b95e8",
  Datatable_Clock_Icon_bgColor: "#99C4C8",
  Datatable_Edit_Icon_bgColor: "#413F42",
  Datatable_Delete_Icon_bgColor: "#FF4949",
  Disable_Edit_Icon_bgColor:"#D3D3D3",
  Datatable_List_Icon_bgColor: "#205375",
  Datatable_Calender_Icon_bgColor: "#413F42",
  Datatable_PlusIcon_bgColor: "#413F42",
  Sidebar_Title: "#fff",
  Sidebar_Responsive_Menu_Icon: "#a5aaad",
  //----------HEADER----------------------//
  Headre_User_Img_bg: "#008000",

  //----------TABLE-------------------------//
  Table_Edit_Icon: "#0095e8",
  Table_Delete_Icon: "#0095e8",
  Table_Menu_Icon: "#0095e8",
  Table_Info_Icon: "#0095e8",
  Oreder_Table_Action_Icon: "#0095e8",
  Table_Row_Background: "#f9f9f9",
  // Table_Row_Highlighted : ""

  Suces_Button: "#0095e8",
  Danger_BUtton: "",
  Warnning: "",

  //------------LOGO-------------//
  Logo_Uplod_bg: "rgb(246, 247, 248)",
  Logo_border: "#808080",

  Close_Icon: "#cf7070",
  Loading_bg: "rgba(16, 16, 16, 0.356)",
  ProgressBar_bg: "rgba(16, 16, 16, 0.5)",
  ProgressBar_Background: "#0095e8",
  Error_Text: "#D72A2A",

  //----------User----------------------//
  
  User_Card_Background: "linear-gradient(30deg,#ffffff,#ffffff)",
  User_Cancelled_Card_Background: "linear-gradient(30deg,#ED213A,#d5847b)",
  // Delivered_Card_Background: "linear-gradient(30deg,#11998e,#38ef7d)",
  // Revenue_Card_Background: "linear-gradient(30deg,#7F00FF,#E100FF)",
  // Card_Count_Color: "#ffffff",

};

export const Datatable_Icons = {
  PlusIcon: `<i style="color:${color.Datatable_PlusIcon_bgColor};" class="fa fa-plus datatable_action_icons"></i>`,
  Info_Icon: `<i style="color:${color.Datatable_Info_Icon_bgColor};" class="fa fa-info datatable_action_icons"></i>`,
  Clock_Icon: `<i style="color:${color.Datatable_Clock_Icon_bgColor};" class="fa fa-clock-o datatable_action_icons"></i>`,
  Edit_Icon: `<i style="color:${color.Datatable_Edit_Icon_bgColor};" class="fa fa-edit datatable_action_icons"></i>`,
  // Disable_Edit_Icon: `<i class="fa fa-edit datatable_action_icons"></i>`,
  Disable_Edit_Icon: `<i style="color:${color.Disable_Edit_Icon_bgColor};" class="fa fa-edit datatable_action_icons"></i>`,
  Delete_Icon: `<i style="color:${color.Datatable_Delete_Icon_bgColor};" class="fa fa-trash datatable_action_icons"></i>`,
  List_Icon: `<i style="color:${color.Datatable_List_Icon_bgColor};" class="fa fa-bars datatable_action_icons"></i>`,
  GalleryIcon: `<i style="color:${color.Datatable_List_Icon_bgColor};" class="fa fa-picture-o datatable_action_icons"></i>`,
  printIcon: `<i style="color:${color.Datatable_List_Icon_bgColor};" class="fa fa-print datatable_action_icons"></i>`,
  CalenderIcon: `<i style="color:${color.Datatable_Calender_Icon_bgColor};" class="fa fa-calendar datatable_action_icons"></i>`,
};
